import heading from "@/components/renderers/heading";
import paragraph from "@/components/renderers/paragraph";
import squareImage from "@/components/renderers/square-image";
import alert from "@/components/renderers/alert";
import bucket from "@/components/renderers/bucket";
import container from "@/components/renderers/container";
import flexContainer from "@/components/renderers/flex-container";
import card from "@/components/renderers/card";
import keyVisual from "@/components/renderers/key-visual";
import navbar from "@/components/renderers/navbar";
import anchor from "@/components/renderers/anchor";
import receiptProcessor from "@/components/renderers/receipt-processor"
import productUpload from "@/components/renderers/product-upload"
import formComponent from "@/components/renderers/form-component"
import textInput from "@/components/renderers/text-input"
import stepCard from "@/components/renderers/step-card"
import stepsComponent from "@/components/renderers/steps-component"
import selectInput from "@/components/renderers/select-input"
import selectInputCounty from "@/components/renderers/select-input-county"
import selectInputCity from "@/components/renderers/select-input-city"
import radioInput from "@/components/renderers/radio-input"
import dateInput from "@/components/renderers/date-input"
import buttonComponent from "@/components/renderers/button-component"
import productSelection from "@/components/renderers/ProductSelection/index.vue"
import emptyBucket from "@/components/renderers/empty-bucket"
import receiptInformation from "@/components/renderers/receipt-information"
import smsVerification from "@/components/renderers/SmsVerification/sms-verification"
import checkbox from "@/components/renderers/checkbox"
import gtinComponent from "@/components/renderers/gtin-component"
import stepCounter from "@/components/renderers/step-counter"
import footerComponent from "@/components/renderers/footer-component"
import stepsHorizontal from "@/components/renderers/steps-horizontal"
import participations from "@/components/renderers/participations"
import question from "@/components/renderers/question"
import textList from "@/components/renderers/text-list"
import reclaimBucket from "@/components/renderers/reclaim-bucket"
import injectTag from "@/components/renderers/inject-tag"
import dataLayerEvent from "@/components/renderers/datalayer-event"
import refreshToken from "@/components/renderers/refresh-token"
import segmentaCookieHandler from "@/components/renderers/segmenta-cookieHandler"
import background from "@/components/renderers/background"
import doi from "@/components/renderers/doi"
import queryStringToState from "@/components/renderers/query-string-to-state"
import thankYou from "@/components/renderers/thank-you";
import thankYouWinner from "@/components/renderers/thank-you-winner";
import multiCampaign from "@/components/renderers/multi-campaign";
import participa from '@/components/renderers/participa';
import errorPage from '@/components/renderers/error-page';
import expiredPage from '@/components/renderers/expired-page';
import receiptImageInformation from '@/components/renderers/receipt-image-information';
import textArea from "@/components/renderers/text-area"
import docsEmbed from "@/components/renderers/docs-embed";
import checkReceiptToken from "@/components/renderers/checkReceiptToken"
import gRecaptcha from "@/components/renderers/google-recaptcha-v2"
import pdfViewer from "@/components/renderers/pdf-viewer"
import ibanReupload from "@/components/renderers/iban-reupload.vue";

export default [
	queryStringToState,
	segmentaCookieHandler,
	refreshToken,
	dataLayerEvent,
	injectTag,
	reclaimBucket,
	textList,
	question,
	stepCounter,
	receiptInformation,
	smsVerification,
	heading,
	paragraph,
	squareImage,
	alert,
	bucket,
	emptyBucket,
	container,
	flexContainer,
	card,
	keyVisual,
	navbar,
	anchor,
	receiptProcessor,
	productUpload,
	formComponent,
	textInput,
	stepCard,
	stepsComponent,
	selectInput,
	radioInput,
	dateInput,
	buttonComponent,
	productSelection,
	checkbox,
	gtinComponent,
	footerComponent,
	background,
	doi,
	stepsHorizontal,
	participations,
	thankYou,
	thankYouWinner,
	multiCampaign,
	selectInputCounty,
	selectInputCity,
	participa,
	receiptImageInformation,
	errorPage,
	textArea,
	docsEmbed,
	expiredPage,
	checkReceiptToken,
	gRecaptcha,
	pdfViewer,
	ibanReupload
];
